import React, { Component } from "react";
import { connect } from "react-redux";
import Contentify from "../../../content/Contentify";
import Store from "../../../content/Store";
import CellWithTwoLabels from "../../shared/groups/CellWithTwoLabels";
import Article from "../../shared/Article";
import { sentenceToTitleCase } from "../../../helpers/SentenceToTitleCase";
import formatCurrencyAmount from "./../../../helpers/FormatCurrencyAmount";
import customStyles from "../../../assets/css/modules/claims/shortfall-summary.css";

const column = "col-md-4 col-sm-12";

const mapStateToShortfallSummary = (state) => {  
    let distinctTreatmentShortfall = [
      ...new Set(
        state.claimsReducer.selectedPolicy.selectedInvoice &&
          state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Treatments.map(
            (item) => item.HasShortfall
          )
      )
    ];
    let treatmentShortfall =    
    distinctTreatmentShortfall && distinctTreatmentShortfall[0];
  return {
    treatmentShortfall,
    selectedInvoice: state.claimsReducer.selectedPolicy.selectedInvoice,
    treatingProviderName: state.claimsReducer.selectedPolicy.selectedInvoice
      .TreatingProviderName
      ? sentenceToTitleCase(
          state.claimsReducer.selectedPolicy.selectedInvoice
            .TreatingProviderName
        )
        : "the provider",
        payeeName: state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Payee.Name
      ? sentenceToTitleCase(
        state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Payee.Name
      )
      : null,
  };
};

function shouldShowPaymentSummary(selectedInvoice) {
  return (
    !selectedInvoice.PaymentDetails.Payee.IsPayeeTheMember ||
    selectedInvoice.IsPaymentNeededByMember
  );
}

export class ShortfallSummary extends Component {
  static content = Store.PaymentDetails.shortfallSummary;
  render() {
    let shortfallSummaryAmountPaidLabel = "";
    let shortfallSummaryAmountPaid = "";
    let shortfallSummaryForMemberHeader = "";
    let shortfallSummaryForMemberBody = "";
    let payeeLabel = "";

    if (this.props.selectedInvoice.IsPaymentNeededByMember) {
      shortfallSummaryForMemberHeader = this.props.content
        .howToPayYourContributionTitle;
      shortfallSummaryForMemberBody = this.props.content
        .howToPayYourContributionBody;
    } else if (
      this.props.selectedInvoice.PaymentDetails.Payee.IsPayeeTheMember
    ) {
      shortfallSummaryForMemberHeader = this.props.content.howWePayYouTitle;
      shortfallSummaryForMemberBody = this.props.content.howWePayYouBody(
        this.props.selectedInvoice.InvoiceDate
      );
    } else {
      shortfallSummaryForMemberHeader = this.props.content
        .howWePayProviderWithNoShortfallTitle;
      shortfallSummaryForMemberBody = this.props.content
        .howWePayProviderWithNoShortfallBody;
    }

    if (this.props.selectedInvoice.IsPaymentNeededByMember) {
      shortfallSummaryAmountPaidLabel = this.props.content.whatToPayTopLabel;
      shortfallSummaryAmountPaid = this.props.selectedInvoice.PaymentDetails
        .TotalMemberLiabilityAmount;
      payeeLabel = this.props.content.whoToPayLabel;
    } else {
      shortfallSummaryAmountPaidLabel = this.props.content.weHavePaidTopLabel;
      shortfallSummaryAmountPaid = this.props.selectedInvoice.PaymentDetails
        .AmountPaid;
      payeeLabel = this.props.content.whoWeHavePaidTopLabel;
    }

    shortfallSummaryForMemberHeader = (
      <h2>{shortfallSummaryForMemberHeader}</h2>
    );
    return (
      <div
        id="shortfallSummary"
        className={
          "row" +
          customStyles.shortfallSummary +
          (shouldShowPaymentSummary(this.props.selectedInvoice)
            ? " " + customStyles.selectedInvoiceShortfallPaddingBottom
            : "")
        }
      >
        <div className="row">
          <div className="col-12">
            <Article
              header={shortfallSummaryForMemberHeader}
              body={shortfallSummaryForMemberBody}
            />
          </div>
        </div>
        {shouldShowPaymentSummary(this.props.selectedInvoice) ? (
          <div className="row">
            <div className={`${column} ${customStyles.column}`}>
              <div id="amountPaid">
                <CellWithTwoLabels
                  styles={customStyles}
                  topLabel={shortfallSummaryAmountPaidLabel}
                  bottomLabel={formatCurrencyAmount(shortfallSummaryAmountPaid)}
                />
              </div>
            </div>
            <div className={`${column} ${customStyles.column}`}>
              <div id="whoWeHavePaid">
                <CellWithTwoLabels
                  styles={customStyles}
                  topLabel={payeeLabel}
                  bottomLabel={this.props.treatingProviderName}
                />
               {this.props.treatmentShortfall && this.props.payeeName != null ?
                 (<CellWithTwoLabels
                  styles={customStyles}
                  topLabel={this.props.content.accountNameLabel}
                  bottomLabel={
                    this.props.payeeName
                    }/>
                  ) : null } 
              </div>
            </div>
            <div className={`${column} ${customStyles.column}`}>
              <div id="providerReference">
                <CellWithTwoLabels
                  styles={customStyles}
                  topLabel={this.props.content.providerReferenceTopLabel}
                  bottomLabel={
                    this.props.selectedInvoice.ProviderInvoiceReference
                  }
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToShortfallSummary)(
  Contentify(ShortfallSummary)
);
